module.exports = __webpack_public_path__ + "static/media/Full of Bricks.56279a38.jpg";